//local synchronous validation to check if the same creative name appears multiple times in the current form
export const creativeNameUnique = (value, allValues) => {
	//count how many times this creative's name appears in the form
	let count = allValues?.creatives?.reduce((nameCount, creative) => {
		return creative?.creativeName === value ? nameCount + 1 : nameCount;
	}, 0);
	//if the creative name appears more than once, it must not be unique
	return count > 1 ? 'Creative name must be unique' : undefined;
};
